import {inlineError} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

export class GetTrackingPhoneDealerUseCase extends UseCase {
  constructor({config, getTrackingPhoneDealerService, fromParamsToTrackingPhoneRequestParamsValueObjectMapper}) {
    super()
    this._config = config
    this._getTrackingPhoneDealerService = getTrackingPhoneDealerService
    this._fromParamsToTrackingPhoneRequestParamsValueObjectMapper =
      fromParamsToTrackingPhoneRequestParamsValueObjectMapper
  }

  /**
   * @return {TrackingPhoneDealerValueObject}
   */
  @inlineError
  async execute(params) {
    const PAGE_TYPES = this._config.get('dealer').PAGE_TYPES
    const adobeAccount = this._config.get('ADOBE_ACCOUNT_URL')
    const sessionId = ''
    const {adId} = params
    const hasAdId = Boolean(adId)

    const trackingPhoneRequestParamsVO = this._fromParamsToTrackingPhoneRequestParamsValueObjectMapper.map({
      sessionId,
      pageType: hasAdId ? PAGE_TYPES.AD : PAGE_TYPES.STOCK,
      adobeAccount,
      params
    })

    const [error, trackingPhoneVO] = await this._getTrackingPhoneDealerService.execute({
      trackingPhoneRequestParamsVO
    })

    if (error) return Promise.reject(error)

    return trackingPhoneVO.toJSON()
  }
}
